import { Button } from 'shards-react'
import React from 'react'
import addFont from '../../../../fonts/fonts'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import styles from '../styles.module.css'

const orientation = 'l'
const fileTitle = `Форма №1/СВУ`

export default function Buttons ({ visible, orgName }) {

  const getPdfData = async () => {
    addFont(jsPDF.API)
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation })

    const {width, height} = doc.internal.pageSize
    let lastY = 10

    const getY = (indent, newValue) => {
      let newY = newValue ? newValue + indent : lastY + indent
      if (newY > height - 15) {
        doc.addPage('a4', orientation)
        newY = 10
      }
      lastY = newY
      return newY
    }

    doc.setFont('Montserrat')

    doc.setFontSize('10')
    doc.text('Форма №1/СВУ', width - 10, lastY, { align: 'right' })
    lastY = getY(8)

    if (orgName) {
      doc.setFontSize('12')
      const lines = doc.splitTextToSize(orgName, width - 20)
      lines.forEach(line => {
        doc.text(line, width/2, lastY, 'center')
        lastY = getY(6)
      })
      lastY = getY(4)
    }

    const table9 = document.getElementById('giaTable_9')
    const table11 = document.getElementById('giaTable_11')

    const tableOptions = {
      styles: { font: 'Montserrat', fontSize: 6 },
      headStyles: {
        halign: 'center',
        valign: 'middle',
        lineWidth: 0.25,
        lineColor: 200,
        minCellHeight: 25,
        cellPadding: 2,
      },
      bodyStyles: {
        halign: 'center',
        lineWidth: 0.25,
        lineColor: 200,
      },
      columnStyles: {
        0: { halign: 'left', cellWidth: 60 },
      },
      didParseCell: (data) => {
        if (data.section === 'head' && data.column.index > 0 && data.cell.colSpan === 1) {
          data.cell._text = data.cell.text
          data.cell.text = []
        }
      },
      didDrawCell: (data) => {
        if (data.section === 'head' && data.cell._text?.length) {
          const text = data.cell._text.join(' ')
          if (text) {
            const { x, y, width: cw, height: ch } = data.cell
            const padding = 2
            const maxTextWidth = ch - padding * 2
            doc.setFontSize(6)
            doc.setFont('Montserrat')
            const lines = doc.splitTextToSize(text, maxTextWidth)
            const lineHeight = 3
            const totalHeight = lines.length * lineHeight
            let startX = x + cw / 2 - totalHeight / 2 + lineHeight / 2
            lines.forEach(line => {
              doc.text(line, startX, y + ch - padding, { angle: 90 })
              startX += lineHeight
            })
          }
        }
      },
    }

    if (table9) {
      doc.setFontSize('11')
      // Экспорт первой таблицы (9 класс)
      doc.text('Сведения о результатах сдачи государственной итоговой аттестации', width/2, lastY, 'center')
      doc.text('по образовательным программам', width/2, getY(7), 'center')
      doc.setFontSize('10')
      doc.text('основного общего образования', width/2, getY(7), 'center')

      doc.autoTable({ html: '#giaTable_9', startY: getY(7), ...tableOptions })
    }

    // Экспорт второй таблицы (11 класс)
    if (table11) {

      if (table9) {
        doc.addPage('a4', orientation)
        lastY = 10
      }

      doc.setFontSize('11')
      doc.text('Сведения о результатах сдачи государственной итоговой аттестации', width/2, lastY, 'center')
      doc.text('по образовательным программам', width/2, getY(7), 'center')
      doc.setFontSize('10')
      doc.text('среднего общего образования', width/2, getY(7), 'center')

      doc.autoTable({ html: '#giaTable_11', startY: getY(7), ...tableOptions })
    }

    doc.addPage('a4', orientation)
    doc.deletePage(doc.getCurrentPageInfo().pageNumber)

    return doc
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`${fileTitle}.pdf`))
  }
  
  if (!visible) return null;

  return (
    <div className={styles.buttonsBlock}>
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </div>
  )
}
